import { parseFilters } from "../../../../../../helpers/url.js";
const getSearcher = ()=>async (endpoint, params, BaseUrl = '')=>{
        if (!endpoint || !BaseUrl || !params) return undefined;
        let url = `${endpoint}?${parseFilters(params)}`;
        if (!endpoint.startsWith('http')) url = `${BaseUrl}${url}`;
        const response = await fetch(url);
        if (!response.ok || response.status !== 200 && response.status !== 204) throw new Error(response.statusText);
        return response.json();
    };
export const getFlightHotelSearcher = getSearcher();
export const getTrainHotelSearcher = getSearcher();
export const getFerryHotelSearcher = getSearcher();
export const getActivitiesSearcher = getSearcher();

//# sourceMappingURL=service.js.map